module.exports = __webpack_public_path__ + "media/mypage/images/jisseki/jisseki06_pc-9dc43cce6a6952f8c68f772608da5d27.jpg";